import gql from 'graphql-tag';

export const deleteExternalContactList = gql`
  mutation deleteExternalContactList($id: String!) {
    deleteExternalContactList(id: $id) {
      value
    }
  }
`;
